import { CheckCircle2, PlayCircle } from "lucide-react";

/**
 * A mockup of the IntelliStitch pattern viewer UI.
 * Shows the Plan/Knit/Finish tab structure, progress, and a current row instruction
 * so visitors can visualise what using the tool actually looks like.
 */
export const PatternPreviewCard = () => {
  return (
    <div className="relative">
      {/* Depth shadow */}
      <div className="absolute inset-0 translate-x-3 translate-y-3 bg-yarn-orchid/20 rounded-2xl" />

      <div className="relative bg-yarn-woolWhite border border-yarn-quartz rounded-2xl shadow-lg overflow-hidden max-w-sm">
        {/* Header */}
        <div className="px-5 pt-5 pb-4 border-b border-yarn-quartz">
          <p className="text-xs font-medium text-yarn-mulberry uppercase tracking-wide mb-0.5">
            Your Pattern
          </p>
          <h3 className="font-playfair text-lg font-bold text-yarn-slate leading-tight">
            Ribbed Toque
          </h3>
          <p className="text-xs text-yarn-slate/60 mt-0.5">DK Weight · 96 sts · Worked in the round</p>
        </div>

        {/* Tab bar */}
        <div className="flex border-b border-yarn-quartz text-xs font-medium">
          <button className="flex-1 py-2.5 text-yarn-slate/50 hover:text-yarn-slate transition-colors">
            Plan
          </button>
          <button className="flex-1 py-2.5 text-primary border-b-2 border-primary bg-primary/5">
            Knit
          </button>
          <button className="flex-1 py-2.5 text-yarn-slate/50 hover:text-yarn-slate transition-colors">
            Finish
          </button>
        </div>

        <div className="px-5 py-4 space-y-4">
          {/* Progress */}
          <div>
            <div className="flex justify-between items-center mb-1.5">
              <span className="text-xs font-medium text-yarn-slate">Row 12 of 48</span>
              <span className="text-xs text-yarn-slate/50">25%</span>
            </div>
            <div className="w-full bg-yarn-quartz rounded-full h-1.5">
              <div className="bg-primary h-1.5 rounded-full" style={{ width: "25%" }} />
            </div>
          </div>

          {/* Current row */}
          <div className="bg-primary/5 border border-primary/15 rounded-lg px-4 py-3">
            <p className="text-xs font-medium text-primary mb-1">Current row</p>
            <p className="font-mono text-sm text-yarn-slate font-medium">
              *K2, P2; rep from * to end.
            </p>
          </div>

          {/* Completed rows */}
          <div className="space-y-2">
            {["CO — 96 sts. Join, pm.", "Rnds 1–11: *K2, P2; rep to end."].map((row) => (
              <div key={row} className="flex items-start gap-2">
                <CheckCircle2 size={14} className="text-yarn-juniper flex-shrink-0 mt-0.5" />
                <p className="font-mono text-xs text-yarn-slate/50 leading-relaxed">{row}</p>
              </div>
            ))}
          </div>

          {/* Tutorial chip */}
          <div className="flex items-center gap-2 bg-yarn-quartz/60 rounded-lg px-3 py-2">
            <PlayCircle size={16} className="text-yarn-mulberry flex-shrink-0" />
            <span className="text-xs text-yarn-slate font-medium">K2, P2 Rib — stitch guide</span>
          </div>
        </div>
      </div>
    </div>
  );
};
